module.exports = __webpack_public_path__ + "img/秒杀列表头部背景图.d68dfbbd.png";